module.exports = "/_next/static/images/OgReverseEtl-891d6b67a282d8a9c3073398153cdad3.png";